// extracted by mini-css-extract-plugin
export var list = "PostList-module--list--3EO5s";
export var frontmatter = "PostList-module--frontmatter--yRL78";